import _defineProperty from "/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { resetComponent, resetIcon, textEllipsis } from '../../style';
import { genCompactItemStyle } from '../../style/compact-item';
import { genStyleHooks, mergeToken } from '../../theme/internal';
import genDropdownStyle from './dropdown';
import genMultipleStyle from './multiple';
import genSingleStyle from './single';
import { prepareComponentToken } from './token';
import genVariantsStyle from './variants';
// ============================= Selector =============================
var genSelectorStyle = function genSelectorStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty(_defineProperty({
    position: 'relative',
    transition: "all ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut),
    input: {
      cursor: 'pointer'
    }
  }, "".concat(componentCls, "-show-search&"), {
    cursor: 'text',
    input: {
      cursor: 'auto',
      color: 'inherit',
      height: '100%'
    }
  }), "".concat(componentCls, "-disabled&"), {
    cursor: 'not-allowed',
    input: {
      cursor: 'not-allowed'
    }
  });
};
// ============================== Styles ==============================
// /* Reset search input style */
var getSearchInputWithoutBorderStyle = function getSearchInputWithoutBorderStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-selection-search-input"), {
    margin: 0,
    padding: 0,
    background: 'transparent',
    border: 'none',
    outline: 'none',
    appearance: 'none',
    fontFamily: 'inherit',
    '&::-webkit-search-cancel-button': {
      display: 'none',
      '-webkit-appearance': 'none'
    }
  });
};
// =============================== Base ===============================
var genBaseStyle = function genBaseStyle(token) {
  var antCls = token.antCls,
    componentCls = token.componentCls,
    inputPaddingHorizontalBase = token.inputPaddingHorizontalBase,
    iconCls = token.iconCls;
  return _defineProperty(_defineProperty({}, componentCls, Object.assign(Object.assign({}, resetComponent(token)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    position: 'relative',
    display: 'inline-flex',
    cursor: 'pointer'
  }, "&:not(".concat(componentCls, "-customize-input) ").concat(componentCls, "-selector"), Object.assign(Object.assign({}, genSelectorStyle(token)), getSearchInputWithoutBorderStyle(token))), "".concat(componentCls, "-selection-item"), Object.assign(Object.assign({
    flex: 1,
    fontWeight: 'normal',
    position: 'relative',
    userSelect: 'none'
  }, textEllipsis), _defineProperty({}, "> ".concat(antCls, "-typography"), {
    display: 'inline'
  }))), "".concat(componentCls, "-selection-placeholder"), Object.assign(Object.assign({}, textEllipsis), {
    flex: 1,
    color: token.colorTextPlaceholder,
    pointerEvents: 'none'
  })), "".concat(componentCls, "-arrow"), Object.assign(Object.assign({}, resetIcon()), _defineProperty(_defineProperty(_defineProperty({
    position: 'absolute',
    top: '50%',
    insetInlineStart: 'auto',
    insetInlineEnd: inputPaddingHorizontalBase,
    height: token.fontSizeIcon,
    marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
    color: token.colorTextQuaternary,
    fontSize: token.fontSizeIcon,
    lineHeight: 1,
    textAlign: 'center',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    transition: "opacity ".concat(token.motionDurationSlow, " ease")
  }, iconCls, _defineProperty({
    verticalAlign: 'top',
    transition: "transform ".concat(token.motionDurationSlow),
    '> svg': {
      verticalAlign: 'top'
    }
  }, "&:not(".concat(componentCls, "-suffix)"), {
    pointerEvents: 'auto'
  })), "".concat(componentCls, "-disabled &"), {
    cursor: 'not-allowed'
  }), '> *:not(:last-child)', {
    marginInlineEnd: 8 // FIXME: magic
  }))), "".concat(componentCls, "-clear"), {
    position: 'absolute',
    top: '50%',
    insetInlineStart: 'auto',
    insetInlineEnd: inputPaddingHorizontalBase,
    zIndex: 1,
    display: 'inline-block',
    width: token.fontSizeIcon,
    height: token.fontSizeIcon,
    marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
    color: token.colorTextQuaternary,
    fontSize: token.fontSizeIcon,
    fontStyle: 'normal',
    lineHeight: 1,
    textAlign: 'center',
    textTransform: 'none',
    cursor: 'pointer',
    opacity: 0,
    transition: "color ".concat(token.motionDurationMid, " ease, opacity ").concat(token.motionDurationSlow, " ease"),
    textRendering: 'auto',
    '&:before': {
      display: 'block'
    },
    '&:hover': {
      color: token.colorTextTertiary
    }
  }), "&:hover ".concat(componentCls, "-clear"), {
    opacity: 1,
    background: token.colorBgBase,
    borderRadius: '50%'
  }))), "".concat(componentCls, "-has-feedback"), _defineProperty({}, "".concat(componentCls, "-clear"), {
    insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
  }));
};
// ============================== Styles ==============================
var genSelectStyle = function genSelectStyle(token) {
  var componentCls = token.componentCls;
  return [_defineProperty({}, componentCls, _defineProperty({}, "&".concat(componentCls, "-in-form-item"), {
    width: '100%'
  })),
  // =====================================================
  // ==                       LTR                       ==
  // =====================================================
  // Base
  genBaseStyle(token),
  // Single
  genSingleStyle(token),
  // Multiple
  genMultipleStyle(token),
  // Dropdown
  genDropdownStyle(token), // =====================================================
  // ==                       RTL                       ==
  // =====================================================
  _defineProperty({}, "".concat(componentCls, "-rtl"), {
    direction: 'rtl'
  }),
  // =====================================================
  // ==             Space Compact                       ==
  // =====================================================
  genCompactItemStyle(token, {
    borderElCls: "".concat(componentCls, "-selector"),
    focusElCls: "".concat(componentCls, "-focused")
  })];
};
// ============================== Export ==============================
export default genStyleHooks('Select', function (token, _ref) {
  var rootPrefixCls = _ref.rootPrefixCls;
  var selectToken = mergeToken(token, {
    rootPrefixCls: rootPrefixCls,
    inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: token.multipleItemHeight,
    selectHeight: token.controlHeight
  });
  return [genSelectStyle(selectToken), genVariantsStyle(selectToken)];
}, prepareComponentToken, {
  unitless: {
    optionLineHeight: true,
    optionSelectedFontWeight: true
  }
});